// Necessary to build the front end styles.
import '@ampblocks/style.scss';

import '@ampblocks/Blocks/QueryFilters/PostDateFilter/front';
import '@ampblocks/Blocks/QueryFilters/TaxonomyFilter/front';
import '@ampblocks/Blocks/QueryFilters/FilterContainer/front';
import '@ampblocks/Blocks/TabLayout/front';
import '@ampblocks/Blocks/Popover/front';
import '@ampblocks/Blocks/InnerblockAccordion/front';
import '@ampblocks/Blocks/SemanticWrapper/front';
import '@ampblocks/Blocks/Formats/Animate/animate-view';
import '@ampblocks/Blocks/Formats/Tooltip/tooltip-view';

console.log(`[AmpBlocks] Front script loaded`);
